export default function accordion() {
	var acc = document.getElementsByClassName('accordion');

	for (var i = 0; i < acc.length; i++) {
		acc[i].addEventListener('click', function() {
			if (this.className.includes('active')) {
				accordionOff(this);
				return true;
			} else {
				for (i = 0; i < acc.length; i++) {
					if (acc[i].className.includes('active')) {
						accordionOff(acc[i]);
					}
				}
			}
			accordionOn(this);
		});

		function accordionOn(element) {
			element.classList.add('active');
			panelTrigger(element);
		}

		function accordionOff(element) {
			element.classList.remove('active');
			panelTrigger(element);
		}

		function panelTrigger(element) {
			var panel = element.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + 'px';
			}
		}
	}

	if (document.getElementsByClassName('accordion').length) {
		var first = document.getElementsByClassName('accordion')[0];
		first.click();
	} else {
		return null;
	}
}
accordion();
